import React, { useState, useEffect } from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import get from 'lodash/get'

import Button from 'discada/dist/Button'
import Icon from 'discada/dist/Icon'
import { RawExpando } from 'discada/dist/Expando'
import { SALES_ROOFTOPS } from 'utils'
import SalesLeadForm from 'components/forms/SalesLeadForm'

import { getIsLoggedIn, getIsDealerBrowser } from 'selectors/authSelectors'
import { getQuery, getQueryValue } from 'selectors/pageStateSelectors'
import {
  addToPageState,
  pushRooftopRoute,
  removeFromPageState,
} from 'actions/pageStateActions'

import {
  getRooftopId,
  getTaggedCustomerFromState,
  getSqueezeCount,
} from 'selectors/appStatusSelectors'

import { updateAbeChatPosition } from 'actions/appStatusActions'
import { getAbeChatPosition } from 'selectors/appStatusSelectors'

import abe from 'static/images/abe/abe.png'
import abeLol from 'static/images/abe/abe-lol.png'
import abeHi from 'static/images/abe/abe-hi.png'
import abeMoney from 'static/images/abe/abe-money.png'
import abeXray from 'static/images/abe/abe-xray.png'

import './AbeChat.scss'
import 'components/Quote/Reactions.scss'

const DELAY = 0 * 20 * 1000

export function AbeChat(props) {
  let {
      className,
      currentAbeChatPosition,
      updateAbeChatPosition,
      removeFromPageState,
      abeOk,
    } = props,
    [open, setOpen] = useState(props.open),
    [openOk, setOpenOk] = useState(),
    contentKey = currentAbeChatPosition,
    Content = CONTENT[contentKey]

  useEffect(() => openOk && setOpen(true), [openOk])

  const goto = step => {
      removeFromPageState(['sessionId', 'magicLinker', 'paymentIQ'])
      updateAbeChatPosition(step)
    },
    reset = () => goto('greeting'),
    toggle = () => setOpen(!open)

  if (!abeOk) return null

  window.setTimeout(() => setOpenOk(true), DELAY)

  return (
    <RawExpando open={open}>
      {() => {
        return (
          <div className={c('abe-chat', className, contentKey)}>
            {open && Content && (
              <div className="abe-chat-inner">
                <Content {...props} toggle={toggle} reset={reset} />

                <div className="abe-controls">
                  {currentAbeChatPosition !== 'greeting' && (
                    <>
                      <Button size="small" text onClick={reset}>
                        Start Over
                      </Button>
                    </>
                  )}
                  <Button size="small" text onClick={toggle}>
                    Hide
                  </Button>
                </div>
              </div>
            )}
            <div className="abe-head" onClick={toggle}>
              {!open && <Icon icon="hand-pointer" />}
              <img src={ABE[contentKey]} className="logo" alt="Abe says..." />
              {!open && HEADERS[contentKey] && (
                <div className="abe-callout">
                  <span>{HEADERS[contentKey](props)}</span>
                </div>
              )}
            </div>
          </div>
        )
      }}
    </RawExpando>
  )
}

function mapStateToProps(state, op) {
  let dealerId = getRooftopId(state),
    isSalesRooftop = SALES_ROOFTOPS.includes(dealerId),
    existingLead = getTaggedCustomerFromState(state),
    squeezeCount = getSqueezeCount(state),
    name = get(existingLead, 'firstName'),
    forceAbe = getQueryValue(state, 'forceAbe')

  return {
    ...op,
    name,
    existingLead,
    squeezeCount,
    queryParams: getQuery(state),
    abeOk:
      forceAbe ||
      (isSalesRooftop &&
        !getIsLoggedIn(state) &&
        !getIsDealerBrowser(state) &&
        squeezeCount > 5),
    sessionId: get(getTaggedCustomerFromState(state), 'sessionId'),
    currentAbeChatPosition: getAbeChatPosition(state),
  }
}

export default connect(
  mapStateToProps,
  {
    updateAbeChatPosition,
    pushRooftopRoute,
    addToPageState,
    removeFromPageState,
  },
)(AbeChat)

/////////////////////

const BuyButton = ({ updateAbeChatPosition }) => (
  <Button
    rounded
    size="small"
    className={c('reaction-button', 'buyNow')}
    onClick={() => updateAbeChatPosition('customizeDemo')}
  >
    <span className="reaction-content">
      <span className="emoji" role="img" aria-label="created">
        🤩
      </span>
      Schedule a <strong>15 minute demo</strong>
    </span>
  </Button>
)

const SalesLeadFloater = ({
    name,
    addToPageState,
    updateAbeChatPosition,
    sessionId,
  }) => (
    <div className="sales-lead-floater-inner">
      <h4 className="greet">{HEADERS.greeting({ name })}</h4>
      <p>
        Engaged customers spend 2 weeks looking at 21 different loan and lease
        options during multiple visits to illumiQUOTE.
      </p>
      <p>
        We track every consumer action and decision to provide unmatched
        visibility to convert more leads to sold customer. Select View MY
        ACTIVITY below to see all your actions update in real-time.
      </p>
      <p>
        <BuyButton updateAbeChatPosition={updateAbeChatPosition} />
        <Button
          rounded
          size="small"
          className={c('reaction-button')}
          onClick={() => {
            addToPageState({ sessionId })
            updateAbeChatPosition('leadDetails')
          }}
        >
          <span className="reaction-content">
            <span className="emoji" role="img" aria-label="created">
              💡
            </span>
            View <strong>my activity</strong>
          </span>
        </Button>
      </p>
    </div>
  ),
  LeadDetails = ({
    addToPageState,
    removeFromPageState,
    updateAbeChatPosition,
  }) => (
    <div className="explainer-inner">
      <h4>{HEADERS.leadDetails()}</h4>
      <p>
        Put on your X-ray goggles and watch everything your customer does in
        real-time. View each customer's desired cash down, payment, and amounts
        along with detailed loan and lease terms to quickly close a deal.
      </p>
      <p>
        Check out the MAGIC LINK below to integrate this exclusive technology on
        every lead channel in your dealership.
      </p>
      <p>
        <BuyButton updateAbeChatPosition={updateAbeChatPosition} />
        <Button
          size="small"
          rounded
          className={c('reaction-button')}
          onClick={() => {
            removeFromPageState('sessionId')
            addToPageState({ magicLinker: true })
            updateAbeChatPosition('magicLink')
          }}
        >
          <span className="reaction-content">
            <span className="emoji" role="img" aria-label="rejected">
              🧐
            </span>
            See <strong>Magic Link</strong>
          </span>
        </Button>
      </p>
    </div>
  ),
  MagicLink = ({
    updateAbeChatPosition,
    addToPageState,
    removeFromPageState,
  }) => (
    <div className="magic-link-inner">
      <h4>{HEADERS.magicLink()}</h4>
      <p>
        Integrate Magic Link technology in your CRM for automated first quality
        responses. Take it to the next level on dead lead campaigns, texts,
        Facebook, and Google advertising to dramatically increase lead
        engagement and conversion.
      </p>
      <p>
        Try it with your CRM and then give WEBSITEiQ a spin to customize how it
        can plug into your website.
      </p>
      <p>
        <BuyButton updateAbeChatPosition={updateAbeChatPosition} />
        <Button
          size="small"
          rounded
          className={c('reaction-button')}
          onClick={() => {
            removeFromPageState('magicLinker')
            addToPageState({ paymentIQ: true })
            updateAbeChatPosition('website')
          }}
        >
          <span className="reaction-content">
            <span className="emoji" role="img" aria-label="rejected">
              🧐
            </span>
            See <strong>WebsiteIQ</strong>
          </span>
        </Button>
      </p>
    </div>
  ),
  WebsiteIq = ({ updateAbeChatPosition }) => (
    <div className="magic-link-inner">
      <h4>{HEADERS.website()}</h4>
      <p>
        Earn trust with your online shoppers through transparency. When they
        trust you, they negotiate less!
      </p>
      <p>
        Customize how payments can look on your website and then Schedule a 15
        MINUTE DEMO with us to see how this fully fits in your dealership.
      </p>
      <p>
        <BuyButton updateAbeChatPosition={updateAbeChatPosition} />
      </p>
    </div>
  ),
  LeadForm = ({ toggle, reset }) => (
    <SalesLeadForm onSave={() => toggle() && reset()} />
  )

const HEADERS = {
  greeting: ({ name }) => `Hi ${name || 'there'}!`,
  leadDetails: () => 'Never miss a Deal!',
  magicLink: () => 'Explode Lead Engagement!',
  website: () => 'CUSTOMERS BUY PAYMENTS!',
}

const CONTENT = {
  greeting: SalesLeadFloater,
  leadDetails: LeadDetails,
  magicLink: MagicLink,
  website: WebsiteIq,
  customizeDemo: LeadForm,
}

const ABE = {
  greeting: abeHi,
  leadDetails: abeXray,
  magicLink: abeLol,
  website: abeMoney,
  customizeDemo: abe,
}
